/* NeoSpherium · scroll reveal.
   Adds .is-visible to .reveal elements when they enter the viewport,
   matching the v0.8 design (.reveal -> .reveal.is-visible { opacity:1 }).
   Ported for the Liquid theme (the standalone homepage's observer wasn't carried over). */
(function () {
  function run() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-visible');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
    els.forEach(function (e) { io.observe(e); });
    // Safety net: reveal anything already in the initial viewport immediately,
    // so above-the-fold content (the hero) is never stuck hidden if the
    // observer is throttled (e.g. background/inactive tab) on first paint.
    requestAnimationFrame(function () {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      els.forEach(function (e) {
        if (e.getBoundingClientRect().top < vh) { e.classList.add('is-visible'); io.unobserve(e); }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Re-scan when Shopify theme editor injects/reloads sections
  document.addEventListener('shopify:section:load', run);
})();
